import removeFolderInListViewStore from '../actions/store-factory/removeFolderInListViewStore';
import { actionNames } from 'owa-mail-store-actions';
import { subscribe } from 'satcheljs/lib/legacy/stitch';
export default function deleteFolderInListViewStitch() {
    subscribe(actionNames.DeleteFolderAction, function (folderIds) {
        // Delete each folder from the list view store
        // There could be multiple foldersIds if user is deleting a folder that has subfolders
        folderIds.forEach(function (folderId) {
            removeFolderInListViewStore(folderId);
        });
    });
}
//# sourceMappingURL=deleteFolderInListViewStitch.js.map